export default "__VITE_ASSET__Dc78bmyn__"